import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "white-bg-border" }
const _hoisted_9 = { class: "edit-profile-section" }
const _hoisted_10 = { class: "edit-profile-form" }
const _hoisted_11 = { class: "admin-custom-row box-row-2" }
const _hoisted_12 = { class: "admin-input-field" }
const _hoisted_13 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_14 = { class: "admin-input-field" }
const _hoisted_15 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_16 = { class: "admin-input-field" }
const _hoisted_17 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_18 = {
  key: 1,
  class: "error-msg"
}
const _hoisted_19 = { class: "admin-input-field" }
const _hoisted_20 = { class: "admin-upload-profile" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "admin-upload-profile-new" }
const _hoisted_23 = { class: "admin-input-field-submit" }
const _hoisted_24 = { class: "admin-site-footer" }
const _hoisted_25 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_PROFILE_TEXT), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.constants.EDIT_PROFILE_TEXT), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.constants.FIRST_NAME_LABEL), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "editProfileFNameInput",
                        type: "text",
                        placeholder: "",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.firstname]
                      ]),
                      (!_ctx.firstname)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.errMsg), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.constants.LAST_NAME_LABEL), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "editProfileLNameInput",
                        type: "text",
                        placeholder: "",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastname) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.lastname]
                      ]),
                      (!_ctx.lastname)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.errMsg), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1),
                    _withDirectives(_createElementVNode("input", {
                      id: "editProfileEmailInput",
                      type: "email",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ]),
                    (!_ctx.email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.errMsg), 1))
                      : _createCommentVNode("", true),
                    (_ctx.emailError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.emailError), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.constants.PROFILE_PICTURE_LABEL), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("button", {
                        class: "image-upload-input-item-delete-btn",
                        id: "uploaded-img-delete-btn",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearUploadedImage && _ctx.clearUploadedImage(...args)))
                      }),
                      _createElementVNode("img", {
                        src: _ctx.imageUrl,
                        alt: "Profile Picture"
                      }, null, 8, _hoisted_21),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("input", {
                          id: "editProfilePicInput",
                          type: "file",
                          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                          accept: "image/jpeg,image/jpg,image/png"
                        }, null, 32),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.CHANGE_PICTURE_LABEL), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      id: "editProfileSubmitBtn",
                      class: "admin-btn-outline-primary",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args)))
                    }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 1),
                    _createElementVNode("button", {
                      id: "editProfileCancelBtn",
                      class: "admin-btn-outline-secondary",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                    }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ])
  ]))
}